import * as React from 'react';
import { useContext } from "react";
import { SelectedPatientContext } from "../SelectedPatientContext.tsx";
import { Text, Spinner, Avatar, Caption1, Tab, TabList } from "@fluentui/react-components";
import { Card, CardHeader, CardPreview, } from "@fluentui/react-components";
import { HeartPulse20Regular, TextBulletListSquareWarning20Regular, ClipboardTextEditRegular, TimelineRegular } from '@fluentui/react-icons';
import { ScenarioConfiguration } from './scenario-configuration.js';
import { SchedulerConfiguration } from './scheduler-configuration.js';
import { ControlPanelNavigation } from './control-panel-navigation.js';
import { HeartBeatChart } from './heart-beat-chart.js';
import { Console } from './console.js';
import { webLightTheme } from '@fluentui/react-components';
import { API_PATH } from '../Constants.ts';

export const Dashboard = () => {
    const { selectedPatientId} = useContext(SelectedPatientContext);
    
    const convertToSeconds = (datetimeString) => {
        const milliseconds = new Date(datetimeString).getTime();
        const seconds = milliseconds / 1000;
        return seconds;
    };

    const [selectedValue, setSelectedValue] =
        React.useState("manual");

    const onTabSelect = (event, data) => {
        setSelectedValue(data.value);
    };
    const [isConnected, setConnected] = React.useState(false);
    React.useEffect(() => {
        const timer = setInterval(() => {
            if (selectedPatientId===null) return;

            let serverTime;
            fetch(API_PATH.SCREENSHOTS + `?id=${selectedPatientId}&columns[]=timestamp_updated&` + Math.random()).then(
                result => {
                    serverTime = result.headers.get('Server-Time');
                    return result.json();
                }).then(data => {
                    let currentServerTime = convertToSeconds(serverTime);
                    let screenshotTime = convertToSeconds(data.timestamp_updated);
                    setConnected(screenshotTime + 15 > currentServerTime);
                })
                .catch(error => {
                    setConnected(false); // TODO
                });
        }, 1000);
        return () => clearInterval(timer);
    });
    const loadImage = (e) => {
        e.target.src = API_PATH.SCREENSHOTS + `?id=${selectedPatientId}&columns[]=screenshot&raw_data&` + Math.random();
    }

    return <>
        <div className='control-panel-layout'>
            <aside className="sidenav">
                <ControlPanelNavigation />
            </aside>
            <main className="main">
                <div className="main-cards">
                    <Card size='large' className="card">
                        <CardHeader image={<Avatar name="John Dow" badge={{ status: isConnected ? 'available' : 'offline' }} />} header={<Text weight="semibold">John Doe</Text>} description={<Caption1>{isConnected ? 'Connected to the remote therapy session.' : 'Disonnected from the remote therapy session.'}</Caption1>} />
                        <CardPreview>
                            <div style={{ width: '100%', aspectRatio: '460 / 240', background: webLightTheme.colorNeutralBackground2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {isConnected && <img src="" alt="VR stream" width="100%" height="100%" onLoad={loadImage} onError={loadImage} onAbort={loadImage} />}
                                {!isConnected && <Spinner size="small" label="Stream not available..." />}
                            </div>
                        </CardPreview>
                    </Card>
                    <Card size='large' className="card">
                        <CardHeader style={{ marginLeft: '-12px', marginTop: '-12px' }} header={
                            <TabList defaultSelectedValue="manual" selectedValue={selectedValue} onTabSelect={onTabSelect} >
                                <Tab value="manual" icon={<ClipboardTextEditRegular />}>
                                    Manually controlled therapy
                                </Tab>
                                <Tab value="scheduler" icon={<TimelineRegular />}>
                                    Scheduler-controlled therapy
                                </Tab>
                            </TabList>
                        } />

                        <div style={{ height: '385px', overflow: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {selectedValue === "manual" && <ScenarioConfiguration />}
                            {selectedValue === "scheduler" && <SchedulerConfiguration selectedPatientId={selectedPatientId} />}
                        </div>
                    </Card>
                    <Card size='large' className="card" style={{ maxHeight: '262px', paddingBottom: '50px' }}>
                        <CardHeader image={<HeartPulse20Regular />} header={<Text weight="semibold">Heart rate [bpm - beats per minute]</Text>} />
                        <HeartBeatChart />
                    </Card>
                    <Card size='large' className="card" style={{ height: '100%' }}>
                        <CardHeader image={<TextBulletListSquareWarning20Regular />} header={<Text weight="semibold">Console</Text>} />
                        <Console />
                    </Card>
                </div>
            </main>
        </div>
    </>;
};